<!-- <div
    *ngIf="!vertical"
    (click)="
        isChecked = !isChecked;
        onCheckChange.emit(isChecked);
        onCheckChange1.emit($event)
    "
    [class]="!isCheckable ? 'flex  w-full ' : 'flex w-full cursor-pointer '"
>
    <label class="mx-2 cursor-pointer" *ngIf="isCheckable">
        <input
            (click)="isChecked = !isChecked"
            #chechbox
            type="checkbox"
            [checked]="isChecked"
        />
        <div class="c-label"></div>
    </label>
    <div class="flex items-center flex-row justify-between w-full">
        <span class="font-semibold text-nowrap">
            {{ lable }}  
            <span class="text-start font-bold text-[#0D7167]">
                {{ lable2 }}
            </span>
        </span>
       <div
            *ngIf="percentage !== null"
            class="flex flex-col my-1 items-center justify-center mr-auto ml-[5px]  h-[35px] relative"
        >
            <round-progress
                [current]="getNumPerc() ?? 0"
                [max]="100"
                [color]="arcColor"
                [radius]="30"
                [stroke]="7"
                [semicircle]="true"
            />
            <div class="flex flex-col absolute bottom-1">
                <p
                [ngStyle]="{ 'color': arcColor }"
                    class=" font-bold  text-xs"
                >
                    {{ percentage ?? 0 }}%
                </p>
         </div>
      </div>
        <span
            class="text-end w-[145px] grad-main-color bg-clip-text font-bold text-transparent"
        >
            {{ info }}
            <span class="font-semibold text-black text-nowrap">
                {{ info2 }}
            </span></span
        >
    </div>
</div>
<div
    *ngIf="vertical"
    class="flex flex-row justify-between items-center content-center space-y-2 w-full"
>
    <span class="font-semibold text-nowrap">
        {{ lable }}  
    </span>
    <span
        class="grad-main-color mr-auto bg-clip-text font-bold text-transparent"
    >
        {{ info }}
    </span>
    <img [src]="icon" class="m-1 mr-2 w-[37px]" *ngIf="icon" />
</div>  

  -->


<div *ngIf="!vertical" (click)="    
      isChecked = !isChecked;
      onCheckChange.emit(isChecked);
      onCheckChange1.emit($event)
  " [class]="!isCheckable ? 'flex w-full' : 'flex w-full cursor-pointer'">
    <label class="mx-2 cursor-pointer" *ngIf="isCheckable">
        <input (click)="isChecked = !isChecked" #chechbox type="checkbox" [checked]="isChecked" />
        <div class="c-label "></div>
    </label>

    <!-- Main Content -->
    <div class="flex items-center flex-row justify-between w-full  ">
        <span class="text-nowrap w-24   lg:w-20 font-semibold md:text-xs  lg:text-xs lg:font-normal 2xl:font-semibold 2xl:text-base flex items-center ">

            {{ lable }} 
            <span class="text-start w-24 text-[#0D7167] pl-2 text-sm lg:w-20 2xl:font-bold 2xl:text-base">
                {{ lable2 }}
            </span>
        </span>

        <!-- <div *ngIf="percentage !== null" class="flex flex-col my-1 items-center justify-center mx-auto
             h-[35px] lg:h-[30px] relative  ">
            <round-progress [current]="getNumPerc() ?? 0" [max]="100" [color]="arcColor" [radius]="30" [stroke]="7"
                [semicircle]="true" class="  md:scale-50 lg:scale-75 xl:scale-100" />
            <div class="flex flex-col  absolute bottom-1">
                <p [ngStyle]="{ 'color': arcColor }" class="font-bold text-[#0D7167]  text-xs ">
                    {{ percentage ?? 0 }}%
                </p>
            </div>
        </div> -->
 
        <div *ngIf="percentage !== null" class="flex flex-col my-1 items-center justify-center mx-auto h-auto relative">
            <round-progress
                [current]="getNumPerc() ?? 0"
                [max]="100"
                [color]="arcColor"
                [radius]="getDimensions().radius"
                [stroke]="7"
                [semicircle]="true"
                class="!w-12 !h-6 2xl:!w-16 2xl:!h-auto   "
            />
            <div class="flex flex-col absolute md:-bottom-1 sm:-bottom-2">
                <p [ngStyle]="{ 'color': arcColor }" class="font-bold text-[#0D7167]   sm:text-[8px] md:text-[10px] lg:text-xs">
                    {{ percentage ?? 0 }}%
                </p>
            </div>
        </div>


        <span
            class="font-bold w-20 grad-main-color bg-clip-text text-transparent text-nowrap md:text-xs lg:text-xs lg:font-normal  2xl:font-semibold 2xl:text-base">
            {{ info }}
            <span class=" text-black w-20 mr-auto bg-clip-text pl-2
             2xl:font-semibold 2xl:text-base">
                {{ info2 }}  
            </span>
        </span>
    </div>
    
    
    <!-- <div class="grid grid-cols-3 space-y-2 items-center w-full text-center   ">
        
        <span class="text-nowrap w-full font-semibold  lg:text-xs lg:font-normal xl:font-semibold xl:text-base flex items-center justify-center">
            {{ lable }} 
            <span class="text-start w-auto font-bold lg:text-xs lg:font-normal xl:font-semibold xl:text-base">
                {{ lable2 }}
            </span>
        </span>
        <div *ngIf="percentage !== null" class="flex flex-col items-center justify-center mx-auto h-[35px] lg:h-[30px] relative">
            <round-progress [current]="getNumPerc() ?? 0" [max]="100" [color]="arcColor" [radius]="30" [stroke]="7"
                [semicircle]="true" class="scale-100 lg:scale-75 xl:scale-100" />
            <div class="absolute bottom-1 flex justify-center">
                <p [ngStyle]="{ 'color': arcColor }" class="font-bold text-[#0D7167] text-xs">
                    {{ percentage ?? 0 }}%
                </p>
            </div>
        </div>
        <span class="text-end font-semibold w-full  grad-main-color bg-clip-text text-transparent text-nowrap lg:text-xs lg:font-normal xl:font-semibold xl:text-base flex justify-center">
            {{ info }}
            <span class="text-black w-auto mr-1 font-semibold lg:text-xs lg:font-normal xl:font-semibold xl:text-base">
                {{ info2 }}
            </span>
        </span>
    </div> -->
    
</div>

<!-- Vertical Layout (Only Scaling Down for Smaller Screens) -->
<div *ngIf="vertical" class="flex flex-row justify-between items-center content-center space-y-2 w-full">
    <span class="  text-nowrap font-semibold md:text-xs  lg:text-xs lg:font-normal 2xl:font-semibold 2xl:text-base">
        {{ lable }} 
    </span>
    <span class="grad-main-color mr-auto bg-clip-text font-bold text-transparent 
    md:text-xs lg:text-xs lg:font-normal 2xl:font-semibold 2xl:text-base ">
        {{ info }}
    </span>
    <img [src]="icon" class="m-1 mr-2 w-[37px]  md:w-[20px]   " *ngIf="icon" />
</div>